var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content-main"},[_vm._t("top"),_vm._t("bottom")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }